<div class="container-fluid mb-4">
    <div class="row mt-4">
        <div class="col-sm-12">
            <p style="color: red; font-size: 15px;">"Note: Please answer accurately - this drives royalty calculations,
                for questions please work with your manager".</p>
            <h5>What type of organization will be using this information?</h5>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12">
            <uitk-form-field  style="width: 47%">
                <uitk-dropdown style="width: 450px" uitkId="organizationInfo" [items]="coveredLivesList"
                    [(ngModel)]="selectedCoveredLivesType" [enableSelectFlag]="true"
                    (onChange)="onChangeCoveredLivesType($event)">
                </uitk-dropdown>
            </uitk-form-field>
        </div>
        <uitk-form-field-error *ngIf="selectedCoveredLivesType.label == 'Select' && showError"  style="width:475px">
            This field is required.
        </uitk-form-field-error>
    </div>
    <div class="row" *ngIf="livesCountRequired === true">
        <div class="col-sm-12 my-3" style="margin-top: -10px">
            <h5>Number of covered lives:</h5>
        </div>
        <div class="row">
            <div class="col-sm-12" style="margin-top: -10px">
                <uitk-form-field>
                    <input style="width: 50%" appIdFormat uitkInput [(ngModel)]="livesCount" />
                </uitk-form-field>
            </div>
        </div>
        <uitk-form-field-error *ngIf="livesCount <= 0 && selectedCoveredLivesType.label == 'Payer - Covered Lives'"
            style="width: 50%">
            Number of Covered Lives is required.
        </uitk-form-field-error>
    </div>
</div>